import { Table } from "antd";
import "./supervisions-table.scss";

interface Section {
  projectSectionId: string;
  name: string;
  number: string;
}

interface SupervisionsTableProps {
  sections: Section[];
}

export const SupervisionsTable = ({ sections }: SupervisionsTableProps) => {
  const columns = [
    {
      title: "Раздел",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Номер",
      dataIndex: "number",
      key: "number",
      align: "right" as const,
    },
  ];

  return (
    <div className="table-block-supervisions">
      <Table
        columns={columns}
        dataSource={sections}
        rowKey="projectSectionId"
        pagination={false}
      />
    </div>
  );
};

